import React from "react";

import infoCircleIcon from "../../static/info-circle.svg";
import RawFormattedMessage from "./RawFormattedMessage";
import styles from "./MaintenanceBanner.module.css";
import { useMe } from "../me";

const BANNER_START = new Date("2026-05-29T00:00:00Z");
const BANNER_END = new Date("2026-06-01T23:59:59Z");

function isBannerVisible(): boolean {
  const now = new Date();
  return now >= BANNER_START && now <= BANNER_END;
}

export default function MaintenanceBanner() {
  const me = useMe();
  if (!isBannerVisible() || !me?.id) {
    return null;
  }

  return (
    <div className={styles.banner} role="status">
      <img src={infoCircleIcon} alt="Info" />
      <RawFormattedMessage
        id="temporary.banner.message"
        className={styles.message}
      />
    </div>
  );
}
